const WHITELISTED_SIZES = [64, 96, 140, 200, 225, 300, 400, 500, 640, 960, 1200, 1600];
const PATH_SEPARATOR = '/';

export function buildImageUrlByZoomId(imageUrl, zoomId, originalSize, format) {
    const url = new URL(imageUrl);
    const size = WHITELISTED_SIZES.find(wlSize => wlSize >= originalSize);
    return `${url.origin}/thumbs/images/g/${zoomId}${PATH_SEPARATOR}s-l${size}.${format}`;
}
